"use strict";

exports.__esModule = true;
exports.RouterLink = exports.Button = exports.Anchor = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _reactRouterDom = require("react-router-dom");

var _AccessibleFocusButton = _interopRequireDefault(require("./AccessibleFocusButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const RouterLink = (0, _styledComponents.default)(_reactRouterDom.Link)`
    color: ${({
  theme
}) => theme.colors.link.text};
    text-decoration: underline;
    cursor: pointer;

    ${({
  theme
}) => (0, _styledComponents.css)`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.RouterLink = RouterLink;
const Anchor = _styledComponents.default.a`
    color: ${({
  theme
}) => theme.colors.link.text};
    text-decoration: underline;
    cursor: pointer;

    ${({
  theme
}) => (0, _styledComponents.css)`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.Anchor = Anchor;
const Button = (0, _styledComponents.default)(_AccessibleFocusButton.default)`
    display: inline;
    color: ${({
  theme
}) => theme.colors.link.text};
    background-color: transparent;
    text-decoration: underline;
    line-height: inherit;
    border: none;
    box-shadow: none;
    padding: 0;
    cursor: pointer;

    ${({
  theme
}) => (0, _styledComponents.css)`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.Button = Button;